export var Connecting = 'Connecting';
export var Open = 'Open';
export var Closing = 'Closing';
export var Closed = 'Closed';
export var Error = 'Error';